/**
 * Embed theme configuration.
 * Add a new entry keyed by the guestClient URL parameter value.
 *
 * Each theme supports:
 *   primary       – main brand color (buttons, active states, links)
 *   primaryHover  – hover variant of primary
 *   primaryLight  – light tint (badge backgrounds, highlights)
 *   primaryText   – text color used on primary backgrounds
 *   background    – page background color
 *   accent        – border / ring / focus color
 *   accentText    – text color for accented elements
 */

const embedThemes = {
  default: {
    primary: "#2563EB",       // blue-600
    primaryHover: "#1D4ED8",  // blue-700
    primaryLight: "#EFF6FF",  // blue-50
    primaryText: "#FFFFFF",
    background: "#F9FAFB",    // gray-50
    accent: "#BFDBFE",        // blue-200
    accentText: "#1D4ED8",    // blue-700
  },
  // --- Add clients below ---
  hibank: {
    primary: "#5BAD9B",       // hibank teal (button color)
    primaryHover: "#4A9989",  // darker teal
    primaryLight: "#EEF8F6",  // light teal tint
    primaryText: "#FFFFFF",
    background: "#FFFFFF",    // white
    accent: "#F97316",        // hibank orange (accent)
    accentText: "#F97316",    // orange text for links/headings
  },
};

export default embedThemes;
